import { Injectable, Provider, Type } from '@angular/core';
import { ICartCreationDialogService, ICartCreationDialogServiceToken } from 'shared/services/ui/cart-creation-dialog/cart-creation-dialog-service.abstract';
import { CartCreationDialogBaseService } from 'shared/services/ui/cart-creation-dialog/cart-creation-dialog-base.service';
import { CartCreationDialogComponent } from '../../components/shared/cart/cart-creation-dialog/cart-creation-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class CartCreationDialogService extends CartCreationDialogBaseService<CartCreationDialogComponent> implements ICartCreationDialogService {

  protected getComponent(): Type<any> {
    return CartCreationDialogComponent;
  }

}
/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const CartCreationDialogServiceProvider: Provider[] = [
  { provide: ICartCreationDialogServiceToken, useExisting: CartCreationDialogService }
];
